import createIcon from '../../createIcon';

/**
 * @component @name Phonelink
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNCA2SDIyVjRINEMyLjkgNCAyIDQuOSAyIDZWMTdIMFYyMEgxNFYxN0g0VjZaTTIzIDhIMTdDMTYuNDUgOCAxNiA4LjQ1IDE2IDlWMTlDMTYgMTkuNTUgMTYuNDUgMjAgMTcgMjBIMjNDMjMuNTUgMjAgMjQgMTkuNTUgMjQgMTlWOUMyNCA4LjQ1IDIzLjU1IDggMjMgOFpNMjIgMTdIMThWMTBIMjJWMTdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Phonelink = createIcon('Phonelink', [
  [
    'path',
    {
      d: 'M4 6H22V4H4C2.9 4 2 4.9 2 6V17H0V20H14V17H4V6ZM23 8H17C16.45 8 16 8.45 16 9V19C16 19.55 16.45 20 17 20H23C23.55 20 24 19.55 24 19V9C24 8.45 23.55 8 23 8ZM22 17H18V10H22V17Z',
      key: '1mqelj',
    },
  ],
]);

export default Phonelink;
